import React from 'react'

import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { getLogoUrl } from '../../api/Logo'
import './TournamentFace.css'

import CardHeader from '@mui/material/CardHeader'
const TournamentFace = ({ data, openTournamentData }) => {
  const openCup = () => {
    openTournamentData(data)
  }

  if (data)
    return (
      <Card className="cardtournaments">
        <CardHeader
          avatar={
            data.logocup ? (
              <img
                srcSet={getLogoUrl(data?.logocup)}
                src={getLogoUrl(data?.logocup)}
                alt={data.tournament_name}
                loading="lazy"
                style={{ maxHeight: '50px', paddingLeft: '16px' }}
              />
            ) : (
              <img
                srcSet={`/images/wbg.png`}
                src={`/images/wbg.png`}
                alt={data.tournament_name}
                loading="lazy"
                style={{ maxWidth: '1px' }}
              />
            )
          }
          title={
            <span style={{ fontWeight: 'bold' }}>{data.tournament_name}</span>
          }
          subheader={data.water_body}
          sx={{ paddingBottom: '4px', paddingLeft: '0px' }}
        />
        <CardContent sx={{ paddingTop: '0px' }}>
          <Typography variant="subtitle2">{data.competition_type}</Typography>
          <Typography variant="subtitle2">
            {`Дата: ${data.start_date} - ${data.end_date}`}
          </Typography>

          <Typography variant="subtitle2" gutterBottom>
            {`Статус:  ${data.status_cup} `}
          </Typography>
        </CardContent>
        <CardActions>
          <Button onClick={openCup} size="small">
            Открыть
          </Button>
        </CardActions>
      </Card>
    )
}
{
  /*  */
}
export default TournamentFace
